import Design0_Features from './Design0_Features';
import ModernElite from './Design1_ModernElite';
import VibrantKids from './Design2_VibrantKids';
import ClassicIvy from './Design3_ClassicIvy';
import MinimalistAir from './Design4_MinimalistAir';
import CreativeArts from './Design5_CreativeArts';
import TechFuture from './Design6_TechFuture';
import NatureCampus from './Design7_NatureCampus';
import CompactBento from './Design8_CompactBento';
import BoldTypography from './Design9_BoldTypography';
import InternationalStandard from './Design10_InternationalStandard';
import FutureScholar from './Design11_FutureScholar';
import EcoFriendly from './Design12_EcoFriendly';
import SportingExcellence from './Design13_SportingExcellence';
import AcademicClassic from './Design14_AcademicClassic';
import TechStartup from './Design15_TechStartup';
import ArtisticSoul from './Design16_ArtisticSoul';
import CommunityHub from './Design17_CommunityHub';
import MontessoriPlay from './Design18_MontessoriPlay';
import GlobalCitizen from './Design19_GlobalCitizen';
import InnovationLab from './Design20_InnovationLab';
import ReptonHeritage from './Design21_ReptonHeritage';
import BiophilicHarmony from './Design22_BiophilicHarmony';
import IvyLeagueTradition from './Design23_IvyLeagueTradition';
import BauhausModern from './Design24_BauhausModern';
import DarkAcademia from './Design25_DarkAcademia';
import NordicMinimal from './Design26_NordicMinimal';
import CyberAcademy from './Design27_CyberAcademy';
import GlassCampus from './Design28_GlassCampus';
import EditorialStyle from './Design29_EditorialStyle';
import CorporateTrust from './Design30_CorporateTrust';
import NeoBrutalist from './Design31_NeoBrutalist';
import SoftNeumorphism from './Design32_SoftNeumorphism';
import RetroSynth from './Design33_RetroSynth';
import PaperCraft from './Design34_PaperCraft';
import SpaceExplorer from './Design35_SpaceExplorer';
import OceanicDepths from './Design36_OceanicDepths';
import UrbanStreet from './Design37_UrbanStreet';
import JapaneseZen from './Design38_JapaneseZen';
import SwissGrid from './Design39_SwissGrid';
import MaterialDepth from './Design40_MaterialDepth';
import VintageLibrary from './Design41_VintageLibrary';
import HighTechLab from './Design42_HighTechLab';
import MontessoriNature from './Design43_MontessoriNature';
import ArtDeco from './Design44_ArtDeco';
import ComicBook from './Design45_ComicBook';
import BlueprintArchitect from './Design46_BlueprintArchitect';
import PastelDream from './Design47_PastelDream';
import IndustrialLoft from './Design48_IndustrialLoft';
import HolographicFuture from './Design49_HolographicFuture';
import TypographicPoster from './Design50_TypographicPoster';
import PixelWorld from './Design51_PixelWorld';
import MoroccanMosaic from './Design52_MoroccanMosaic';
import TropicalJungle from './Design53_TropicalJungle';
import SteampunkWorkshop from './Design54_SteampunkWorkshop';
import ClayPlay from './Design55_ClayPlay';
import StoneIvy from './Design56_StoneIvy';
import MemphisStyle from './Design57_MemphisStyle';
import OrigamiFold from './Design58_OrigamiFold';
import ChalkboardArt from './Design59_ChalkboardArt';
import InkParchment from './Design60_InkParchment';
import FilmNoir from './Design61_FilmNoir';
import CandyLand from './Design62_CandyLand';
import ScientificJournal from './Design63_ScientificJournal';
import BohoChic from './Design64_BohoChic';
import RacingTeam from './Design65_RacingTeam';
import LuxuryResort from './Design66_LuxuryResort';
import VirtualReality from './Design67_VirtualReality';
import OldNewspaper from './Design68_OldNewspaper';
import SkateCulture from './Design69_SkateCulture';
import GardenParty from './Design70_GardenParty';
import CorporateClean from './Design71_CorporateClean';
import ExecutiveSuite from './Design72_ExecutiveSuite';
import ModernSaaS from './Design73_ModernSaaS';
import ConsultingFirm from './Design74_ConsultingFirm';
import FintechSecure from './Design75_FintechSecure';
import LegalEagle from './Design76_LegalEagle';
import GlobalLogistics from './Design77_GlobalLogistics';
import MedicalTrust from './Design78_MedicalTrust';
import ArchitecturalFirm from './Design79_ArchitecturalFirm';
import RealEstatePrime from './Design80_RealEstatePrime';
import UniversityModern from './Design81_UniversityModern';
import ResearchLab from './Design82_ResearchLab';
import LibraryArchives from './Design83_LibraryArchives';
import StemAcademy from './Design84_StemAcademy';
import LiberalArts from './Design85_LiberalArts';
import BusinessSchool from './Design86_BusinessSchool';
import LawSchool from './Design87_LawSchool';
import MedicalSchool from './Design88_MedicalSchool';
import EngineeringTech from './Design89_EngineeringTech';
import InternationalBaccalaureate from './Design90_InternationalBaccalaureate';
import CreativeStudio from './Design91_CreativeStudio';
import MinimalistPortfolio from './Design92_MinimalistPortfolio';
import DigitalAgency from './Design93_DigitalAgency';
import TypographyFocus from './Design94_TypographyFocus';
import GallerySpace from './Design95_GallerySpace';
import CulinaryInstitute from './Design96_CulinaryInstitute';
import AviationAcademy from './Design97_AviationAcademy';
import MaritimeInstitute from './Design98_MaritimeInstitute';
import MilitaryAcademy from './Design99_MilitaryAcademy';
import DiplomaticCorps from './Design100_DiplomaticCorps';
import MuseumCollection from './Design101_MuseumCollection';
import ConservatoryMusic from './Design102_ConservatoryMusic';
import TheatreArts from './Design103_TheatreArts';
import FilmSchool from './Design104_FilmSchool';
import FashionDesign from './Design105_FashionDesign';
import SportsManagement from './Design106_SportsManagement';
import HospitalitySchool from './Design107_HospitalitySchool';
import VeterinaryMedicine from './Design108_VeterinaryMedicine';
import EnvironmentalScience from './Design109_EnvironmentalScience';
import PharmacySchool from './Design110_PharmacySchool';
import AnimationStudio from './Design111_AnimationStudio';
import CryptoBlockchain from './Design112_CryptoBlockchain';
import QuantumPhysics from './Design113_QuantumPhysics';
import RenewableEnergy from './Design114_RenewableEnergy';
import UrbanPlanning from './Design115_UrbanPlanning';
import GameDevelopment from './Design116_GameDevelopment';
import ForensicScience from './Design117_ForensicScience';
import ArchaeologyDig from './Design118_ArchaeologyDig';
import AstronomyObservatory from './Design119_AstronomyObservatory';
import PodcastMedia from './Design120_PodcastMedia';
import DronePilot from './Design121_DronePilot';
import CeramicsPottery from './Design122_CeramicsPottery';
import YogaWellness from './Design123_YogaWellness';
import EquestrianCenter from './Design124_EquestrianCenter';
import ScubaDiving from './Design125_ScubaDiving';
import CarpentryWood from './Design126_CarpentryWood';
import ElectricVehicle from './Design127_ElectricVehicle';
import MakeupArtistry from './Design128_MakeupArtistry';
import StandUpComedy from './Design129_StandUpComedy';
import SurvivalSkills from './Design130_SurvivalSkills';
import MaritimeAcademy from './Design131_MaritimeAcademy';
import CulinaryArts from './Design132_CulinaryArts';
import RoboticsEngineering from './Design133_RoboticsEngineering';
import FashionDesignV2 from './Design134_FashionDesign';
import Cinematography from './Design135_Cinematography';
import InteriorDesign from './Design136_InteriorDesign';
import ClassicalConservatory from './Design137_ClassicalConservatory';
import HorticultureBotany from './Design138_HorticultureBotany';
import LawSchoolV2 from './Design139_LawSchool';
import Cybersecurity from './Design140_Cybersecurity';
import SpaceArchitecture from './Design141_SpaceArchitecture';
import SportsScience from './Design142_SportsScience';
import WildlifeConservation from './Design143_WildlifeConservation';
import ArtificialIntelligence from './Design144_ArtificialIntelligence';
import JournalismMedia from './Design145_JournalismMedia';
import SustainableAgriculture from './Design146_SustainableAgriculture';
import IndustrialDesign from './Design147_IndustrialDesign';
import ActingDrama from './Design148_ActingDrama';
import OceanographyResearch from './Design149_OceanographyResearch';
import CreativeWriting from './Design150_CreativeWriting';
import PrincetonUniversity from './Design151_Princeton';
import MIT from './Design152_MIT';
import HarvardUniversity from './Design153_Harvard';
import StanfordUniversity from './Design154_Stanford';
import YaleUniversity from './Design155_Yale';
import Caltech from './Design156_Caltech';
import DukeUniversity from './Design157_Duke';
import JohnsHopkinsUniversity from './Design158_JohnsHopkins';
import NorthwesternUniversity from './Design159_Northwestern';
import UniversityOfPennsylvania from './Design160_UPenn';
import UniversityOfChicago from './Design161_UChicago';
import CornellUniversity from './Design162_Cornell';
import ColumbiaUniversity from './Design163_Columbia';
import BrownUniversity from './Design164_Brown';
import UCLA from './Design165_UCLA';
import UCBerkeley from './Design166_UCBerkeley';
import RiceUniversity from './Design167_Rice';
import DartmouthCollege from './Design168_Dartmouth';
import VanderbiltUniversity from './Design169_Vanderbilt';
import NotreDame from './Design170_NotreDame';
import UniversityOfMichigan from './Design171_UMich';
import GeorgetownUniversity from './Design172_Georgetown';
import UNCChapelHill from './Design173_UNC';
import CarnegieMellon from './Design174_CarnegieMellon';
import EmoryUniversity from './Design175_Emory';
import UniversityOfVirginia from './Design176_UVA';
import WashU from './Design177_WashU';
import USC from './Design178_USC';
import UCSanDiego from './Design179_UCSD';
import UniversityOfFlorida from './Design180_UFlorida';
import UTAustin from './Design181_UTAustin';
import UWMadison from './Design182_UWMadison';
import UIUC from './Design183_UIUC';
import GeorgiaTech from './Design184_GeorgiaTech';
import OhioState from './Design185_OhioState';
import PennState from './Design186_PennState';
import PurdueUniversity from './Design187_Purdue';
import RutgersUniversity from './Design188_Rutgers';
import UMaryland from './Design189_UMaryland';
import TexasAM from './Design190_TexasAM';
import UMassAmherst from './Design191_UMass';
import UCIrvine from './Design192_UCIrvine';
import UCDavis from './Design193_UCDavis';
import UCSantaBarbara from './Design194_UCSB';
import BostonUniversity from './Design195_BU';
import NortheasternUniversity from './Design196_Northeastern';
import MichiganStateUniversity from './Design197_MichiganState';
import ArizonaStateUniversity from './Design198_ASU';
import UniversityOfMinnesota from './Design199_UMinnesota';
import IndianaUniversity from './Design200_Indiana';
import { WebsiteDesignProps } from './types';

export interface DesignTemplate {
    id: string;
    name: string;
    description: string;
    component: React.FC<WebsiteDesignProps>;
}

export const websiteDesigns: DesignTemplate[] = [
    {
        id: 'modern-elite',
        name: 'Modern Elite',
        description: 'A premium, navy & gold aesthetic suitable for top-tier international schools.',
        component: ModernElite,
    },
    {
        id: 'vibrant-kids',
        name: 'Vibrant Kids',
        description: 'Playful, colorful, and fun. Perfect for kindergartens and primary schools.',
        component: VibrantKids,
    },
    {
        id: 'classic-ivy',
        name: 'Classic Ivy',
        description: 'Traditional, serif-heavy design evoking history, prestige, and academic rigor.',
        component: ClassicIvy,
    },
    {
        id: 'minimalist-air',
        name: 'Minimalist Air',
        description: 'Clean, high-contrast, and spacious. Focuses on typography and imagery.',
        component: MinimalistAir,
    },
    {
        id: 'creative-arts',
        name: 'Creative Arts',
        description: 'Dark mode, bold neon accents, and abstract shapes for art & design schools.',
        component: CreativeArts,
    },
    {
        id: 'tech-future',
        name: 'Tech Future',
        description: 'Cyberpunk-inspired grid layout for STEM and technology-focused institutes.',
        component: TechFuture,
    },
    {
        id: 'nature-campus',
        name: 'Nature Campus',
        description: 'Organic, soft greens and cream colors emphasizing outdoor learning.',
        component: NatureCampus,
    },
    {
        id: 'compact-bento',
        name: 'Compact Bento',
        description: 'Grid-based, information-dense layout for efficient communication.',
        component: CompactBento,
    },
    {
        id: 'bold-typography',
        name: 'Bold Typography',
        description: 'Swiss-style design with massive confident text and minimal distractions.',
        component: BoldTypography,
    },
    {
        id: 'international-standard',
        name: 'International Standard',
        description: 'Reliable, corporate-blue layout. Trustworthy and familiar.',
        component: InternationalStandard,
    },
    {
        id: 'future-scholar',
        name: 'Future Scholar',
        description: 'Sci-fi inspired, dark theme with glowing accents for futuristic academies.',
        component: FutureScholar,
    },
    {
        id: 'eco-friendly',
        name: 'Eco Friendly',
        description: 'Earth tones and textured backgrounds for environmentally conscious schools.',
        component: EcoFriendly,
    },
    {
        id: 'sporting-excellence',
        name: 'Sporting Excellence',
        description: 'High energy, slanted layouts, and bold typography for sports academies.',
        component: SportingExcellence,
    },
    {
        id: 'academic-classic',
        name: 'Academic Classic',
        description: 'Old-world charm with parchment textures and traditional serif typography.',
        component: AcademicClassic,
    },
    {
        id: 'tech-startup',
        name: 'Tech Startup',
        description: 'Clean, modern SaaS-style aesthetic for coding bootcamps and tech schools.',
        component: TechStartup,
    },
    {
        id: 'artistic-soul',
        name: 'Artistic Soul',
        description: 'Watercolor effects, irregular shapes, and creative fonts for art schools.',
        component: ArtisticSoul,
    },
    {
        id: 'community-hub',
        name: 'Community Hub',
        description: 'Warm colors and people-focused layout for community schools and centers.',
        component: CommunityHub,
    },
    {
        id: 'montessori-play',
        name: 'Montessori Play',
        description: 'Soft pastels and gentle shapes, perfect for early childhood education.',
        component: MontessoriPlay,
    },
    {
        id: 'global-citizen',
        name: 'Global Citizen',
        description: 'International feel with map motifs and multilingual support cues.',
        component: GlobalCitizen,
    },
    {
        id: 'innovation-lab',
        name: 'Innovation Lab',
        description: 'Technical, monochromatic, and minimal design for research institutes.',
        component: InnovationLab,
    },
    {
        id: 'repton-heritage',
        name: 'Repton Heritage',
        description: 'Replica of the prestigious Repton School design. Oxford Blue, Serif fonts, and clean layouts.',
        component: ReptonHeritage,
    },
    {
        id: 'biophilic-harmony',
        name: 'Biophilic Harmony',
        description: 'Modern organic design integrated with nature, featuring plant motifs and soft greens.',
        component: BiophilicHarmony,
    },
    {
        id: 'ivy-league-tradition',
        name: 'Ivy League Tradition',
        description: 'Deep crimson and gold traditional design evoking prestigious university aesthetics.',
        component: IvyLeagueTradition,
    },
    {
        id: 'bauhaus-modern',
        name: 'Bauhaus Modern',
        description: 'Geometric shapes, primary colors, and stark asymmetry inspired by the Bauhaus movement.',
        component: BauhausModern,
    },
    {
        id: 'dark-academia',
        name: 'Dark Academia',
        description: 'Moody, vintage, and textural aesthetic for schools with a focus on literature and history.',
        component: DarkAcademia,
    },
    {
        id: 'nordic-minimal',
        name: 'Nordic Minimal',
        description: 'Ultra-clean, white, and airy design focusing on simplicity and light.',
        component: NordicMinimal,
    },
    {
        id: 'cyber-academy',
        name: 'Cyber Academy',
        description: 'Neon, glitch effects, and dark mode for e-sports and future-tech focused schools.',
        component: CyberAcademy,
    },
    {
        id: 'glass-campus',
        name: 'Glass Campus',
        description: 'Modern glassmorphism with blurred transparencies and vibrant gradients.',
        component: GlassCampus,
    },
    {
        id: 'editorial-style',
        name: 'Editorial Style',
        description: 'High-fashion magazine layout with bold serif headlines and artistic spacing.',
        component: EditorialStyle,
    },
    {
        id: 'corporate-trust',
        name: 'Corporate Trust',
        description: 'Solid, reliable, and professional design for large educational foundations.',
        component: CorporateTrust,
    },
    {
        id: 'neo-brutalist',
        name: 'Neo Brutalist',
        description: 'High contrast, raw borders, and unstyled HTML vibe for bold statements.',
        component: NeoBrutalist,
    },
    {
        id: 'soft-neumorphism',
        name: 'Soft Neumorphism',
        description: 'Soft shadows, extruded shapes, and a very tactile, gentle interface.',
        component: SoftNeumorphism,
    },
    {
        id: 'retro-synth',
        name: 'Retro Synth',
        description: '80s synthwave aesthetic with neon grids and retro-futuristic vibes.',
        component: RetroSynth,
    },
    {
        id: 'paper-craft',
        name: 'Paper Craft',
        description: 'Collage style with paper textures, cutouts, and hand-drawn elements.',
        component: PaperCraft,
    },
    {
        id: 'space-explorer',
        name: 'Space Explorer',
        description: 'Deep space theme with stars, planets, and a futuristic sci-fi feel.',
        component: SpaceExplorer,
    },
    {
        id: 'oceanic-depths',
        name: 'Oceanic Depths',
        description: 'Deep blues, teal gradients, and fluid wave motifs for marine academies.',
        component: OceanicDepths,
    },
    {
        id: 'urban-street',
        name: 'Urban Street',
        description: 'Graffiti, concrete textures, and bold stencil fonts for creative arts.',
        component: UrbanStreet,
    },
    {
        id: 'japanese-zen',
        name: 'Japanese Zen',
        description: 'Minimalist, vertical layouts, and calming beige/red tones.',
        component: JapaneseZen,
    },
    {
        id: 'swiss-grid',
        name: 'Swiss Grid',
        description: 'Strict grid systems, Helvetica typography, and objective design principles.',
        component: SwissGrid,
    },
    {
        id: 'material-depth',
        name: 'Material Depth',
        description: 'Bright colors, deeper shadows, and layered material design elements.',
        component: MaterialDepth,
    },
    {
        id: 'vintage-library',
        name: 'Vintage Library',
        description: 'Sepia tones, old paper textures, and classic serif fonts.',
        component: VintageLibrary,
    },
    {
        id: 'high-tech-lab',
        name: 'High Tech Lab',
        description: 'Clean room aesthetic, HUD elements, and hexagonal patterns.',
        component: HighTechLab,
    },
    {
        id: 'montessori-nature',
        name: 'Montessori Nature',
        description: 'Warm earth tones, wood textures, and playful organic shapes.',
        component: MontessoriNature,
    },
    {
        id: 'art-deco',
        name: 'Art Deco',
        description: 'Geometric gold patterns, black backgrounds, and Great Gatsby elegance.',
        component: ArtDeco,
    },
    {
        id: 'comic-book',
        name: 'Comic Book',
        description: 'Pop art style with halftones, speech bubbles, and vibrant colors.',
        component: ComicBook,
    },
    {
        id: 'blueprint-architect',
        name: 'Blueprint Architect',
        description: 'Technical blue background with white line drawings and schematic layouts.',
        component: BlueprintArchitect,
    },
    {
        id: 'pastel-dream',
        name: 'Pastel Dream',
        description: 'Soft pinks, purples, and blues creating a dreamy, nursery-like atmosphere.',
        component: PastelDream,
    },
    {
        id: 'industrial-loft',
        name: 'Industrial Loft',
        description: 'Exposed brick, dark metals, and orange accents for a makerspace feel.',
        component: IndustrialLoft,
    },
    {
        id: 'holographic-future',
        name: 'Holographic Future',
        description: 'Iridescent gradients on dark backgrounds, shiny and futuristic.',
        component: HolographicFuture,
    },
    {
        id: 'typographic-poster',
        name: 'Typographic Poster',
        description: 'Massive typography, bold colors, and almost no imagery. Design-led.',
        component: TypographicPoster,
    },
    {
        id: 'pixel-world',
        name: 'Pixel World',
        description: '8-bit retro gaming aesthetic with blocky fonts and pixel art.',
        component: PixelWorld,
    },
    {
        id: 'moroccan-mosaic',
        name: 'Moroccan Mosaic',
        description: 'Intricate geometric patterns, warm terracotta colors, and serif fonts.',
        component: MoroccanMosaic,
    },
    {
        id: 'tropical-jungle',
        name: 'Tropical Jungle',
        description: 'Lush green rainforest themes with vibrant yellow accents.',
        component: TropicalJungle,
    },
    {
        id: 'steampunk-workshop',
        name: 'Steampunk Workshop',
        description: 'Brass gears, steam-powered aesthetic, and dark leather tones.',
        component: SteampunkWorkshop,
    },
    {
        id: 'clay-play',
        name: 'Clay Play',
        description: '3D claymorphism effect, soft rounded shapes, and playful colors.',
        component: ClayPlay,
    },
    {
        id: 'stone-ivy',
        name: 'Stone & Ivy',
        description: 'Gothic architecture, stone textures, and dark academic vibes.',
        component: StoneIvy,
    },
    {
        id: 'memphis-style',
        name: 'Memphis Style',
        description: '80s pop geometric shapes, squiggles, and clashing vibrant colors.',
        component: MemphisStyle,
    },
    {
        id: 'origami-fold',
        name: 'Origami Fold',
        description: 'Paper fold aesthetic with sharp angles and clean creases.',
        component: OrigamiFold,
    },
    {
        id: 'chalkboard-art',
        name: 'Chalkboard Art',
        description: 'Classic green chalkboard background with white chalk-style text.',
        component: ChalkboardArt,
    },
    {
        id: 'ink-parchment',
        name: 'Ink & Parchment',
        description: 'Elegant calligraphy on aged paper backgrounds.',
        component: InkParchment,
    },
    {
        id: 'film-noir',
        name: 'Film Noir',
        description: 'Cinematic black and white, high contrast, and dramatic shadows.',
        component: FilmNoir,
    },
    {
        id: 'candy-land',
        name: 'Candy Land',
        description: 'Saccharine sweet colors, rounded bubbles, and joyful vibes.',
        component: CandyLand,
    },
    {
        id: 'scientific-journal',
        name: 'Scientific Journal',
        description: 'Academic 2-column layout, figures, charts, and serious typography.',
        component: ScientificJournal,
    },
    {
        id: 'boho-chic',
        name: 'Boho Chic',
        description: 'Earthy tones, natural textures, and a free-spirited feel.',
        component: BohoChic,
    },
    {
        id: 'racing-team',
        name: 'Racing Team',
        description: 'High speed, checkered flags, red/black/white race car aesthetic.',
        component: RacingTeam,
    },
    {
        id: 'luxury-resort',
        name: 'Luxury Resort',
        description: 'High-end hospitality feel with gold, black, and elegant amenities.',
        component: LuxuryResort,
    },
    {
        id: 'virtual-reality',
        name: 'Virtual Reality',
        description: 'Metaverse grid lines, floating HUD elements, and cyber aesthetics.',
        component: VirtualReality,
    },
    {
        id: 'old-newspaper',
        name: 'Old Newspaper',
        description: 'Vintage newspaper layout with columns and headline fonts.',
        component: OldNewspaper,
    },
    {
        id: 'skate-culture',
        name: 'Skate Culture',
        description: 'Grunge textures, sticker bombing, and rebellious street style.',
        component: SkateCulture,
    },
    {
        id: 'garden-party',
        name: 'Garden Party',
        description: 'Floral patterns, soft pastels, and elegant tea-party aesthetics.',
        component: GardenParty,
    },
    {
        id: 'corporate-clean',
        name: 'Corporate Clean',
        description: 'Standard efficient business blue/white, sans-serif.',
        component: CorporateClean,
    },
    {
        id: 'executive-suite',
        name: 'Executive Suite',
        description: 'Dark charcoal/gold, high-end business feel.',
        component: ExecutiveSuite,
    },
    {
        id: 'modern-saas',
        name: 'Modern SaaS',
        description: 'Stripe-like, gradients, clean illustrations, tech-focused.',
        component: ModernSaaS,
    },
    {
        id: 'consulting-firm',
        name: 'Consulting Firm',
        description: 'Serif headings, plenty of white space, very trustworthy.',
        component: ConsultingFirm,
    },
    {
        id: 'fintech-secure',
        name: 'Fintech Secure',
        description: 'Greens, locks/shields imagery, stable and solid.',
        component: FintechSecure,
    },
    {
        id: 'legal-eagle',
        name: 'Legal Eagle',
        description: 'Navy/Grey, traditional but sharp, very serious.',
        component: LegalEagle,
    },
    {
        id: 'global-logistics',
        name: 'Global Logistics',
        description: 'Maps, connecting lines, transport blues and oranges.',
        component: GlobalLogistics,
    },
    {
        id: 'medical-trust',
        name: 'Medical Trust',
        description: 'Clean teal/white, health-focused, sterile but welcoming.',
        component: MedicalTrust,
    },
    {
        id: 'architectural-firm',
        name: 'Architectural Firm',
        description: 'Black and white, heavy use of photography, grid-based.',
        component: ArchitecturalFirm,
    },
    {
        id: 'real-estate-prime',
        name: 'Real Estate Prime',
        description: 'Gold/Black, luxurious property vibes, serif fonts.',
        component: RealEstatePrime,
    },
    {
        id: 'university-modern',
        name: 'University Modern',
        description: 'Red/Grey, large hero images, research focus.',
        component: UniversityModern,
    },
    {
        id: 'research-lab',
        name: 'Research Lab',
        description: 'Clean white/blue, data visualization elements.',
        component: ResearchLab,
    },
    {
        id: 'library-archives',
        name: 'Library Archives',
        description: 'Warm wood tones, cream background, literary feel.',
        component: LibraryArchives,
    },
    {
        id: 'stem-academy',
        name: 'STEM Academy',
        description: 'Circuit board patterns but subtle, blue/silver.',
        component: StemAcademy,
    },
    {
        id: 'liberal-arts',
        name: 'Liberal Arts',
        description: 'Soft colors, artistic but restrained, humanist fonts.',
        component: LiberalArts,
    },
    {
        id: 'business-school',
        name: 'Business School',
        description: 'Strong navy, bold sans-serif, career-focused.',
        component: BusinessSchool,
    },
    {
        id: 'law-school',
        name: 'Law School',
        description: 'Maroon/Gold, pillars, scales of justice, very formal.',
        component: LawSchool,
    },
    {
        id: 'medical-school',
        name: 'Medical School',
        description: 'Anatomical sketches (subtle), clean blue, precision.',
        component: MedicalSchool,
    },
    {
        id: 'engineering-tech',
        name: 'Engineering Tech',
        description: 'Blueprints (subtle), geometric, precise.',
        component: EngineeringTech,
    },
    {
        id: 'international-baccalaureate',
        name: 'International Baccalaureate',
        description: 'Globe motifs, diverse imagery, clean.',
        component: InternationalBaccalaureate,
    },
    {
        id: 'creative-studio',
        name: 'Creative Studio',
        description: 'Bold colors but organized, grid layout, portfolio style.',
        component: CreativeStudio,
    },
    {
        id: 'minimalist-portfolio',
        name: 'Minimalist Portfolio',
        description: 'Almost entirely whitespace, large typography.',
        component: MinimalistPortfolio,
    },
    {
        id: 'digital-agency',
        name: 'Digital Agency',
        description: 'Dark mode, vibrant gradients, slick animations.',
        component: DigitalAgency,
    },
    {
        id: 'typography-focus',
        name: 'Typography Focus',
        description: 'Text-heavy but beautiful typesetting.',
        component: TypographyFocus,
    },
    {
        id: 'gallery-space',
        name: 'Gallery Space',
        description: 'White cube aesthetic, framing content like art.',
        component: GallerySpace,
    },
    {
        id: 'culinary-institute',
        name: 'Culinary Institute',
        description: 'Clean white, food photography focus, elegant script.',
        component: CulinaryInstitute,
    },
    {
        id: 'aviation-academy',
        name: 'Aviation Academy',
        description: 'Sky blues, aeronautical elements, clean lines.',
        component: AviationAcademy,
    },
    {
        id: 'maritime-institute',
        name: 'Maritime Institute',
        description: 'Navy/White, nautical but professional.',
        component: MaritimeInstitute,
    },
    {
        id: 'military-academy',
        name: 'Military Academy',
        description: 'Camouflage (subtle) or OD Green/Gold, structured, disciplined.',
        component: MilitaryAcademy,
    },
    {
        id: 'diplomatic-corps',
        name: 'Diplomatic Corps',
        description: 'Flags, very formal, gold/blue, United Nations vibe.',
        component: DiplomaticCorps,
    },
    {
        id: 'museum-collection',
        name: 'Museum Collection',
        description: 'Gallery aesthetic, elegant serif fonts, minimal and refined.',
        component: MuseumCollection,
    },
    {
        id: 'conservatory-music',
        name: 'Conservatory Music',
        description: 'Dark gold elegance for music and performing arts schools.',
        component: ConservatoryMusic,
    },
    {
        id: 'theatre-arts',
        name: 'Theatre Arts',
        description: 'Velvet red, dramatic, classical theatre aesthetic.',
        component: TheatreArts,
    },
    {
        id: 'film-school',
        name: 'Film School',
        description: 'Cinematic black with red accents, film strip aesthetic.',
        component: FilmSchool,
    },
    {
        id: 'fashion-design',
        name: 'Fashion Design',
        description: 'Editorial, high fashion, black and white elegance.',
        component: FashionDesign,
    },
    {
        id: 'sports-management',
        name: 'Sports Management',
        description: 'Dark mode with neon green accents, dynamic and bold.',
        component: SportsManagement,
    },
    {
        id: 'hospitality-school',
        name: 'Hospitality School',
        description: 'Warm gold, Swiss style, luxury hotel feel.',
        component: HospitalitySchool,
    },
    {
        id: 'veterinary-medicine',
        name: 'Veterinary Medicine',
        description: 'Fresh green, caring and professional animal health.',
        component: VeterinaryMedicine,
    },
    {
        id: 'environmental-science',
        name: 'Environmental Science',
        description: 'Dark forest green, nature-focused, earth sciences.',
        component: EnvironmentalScience,
    },
    {
        id: 'pharmacy-school',
        name: 'Pharmacy School',
        description: 'Purple medical theme, pharmaceutical professional.',
        component: PharmacySchool,
    },
    {
        id: 'animation-studio',
        name: 'Animation Studio',
        description: 'Creative, vibrant, motion-focused.',
        component: AnimationStudio,
    },
    {
        id: 'crypto-blockchain',
        name: 'Crypto Blockchain',
        description: 'Futuristic, cyan and digital aesthetic.',
        component: CryptoBlockchain,
    },
    {
        id: 'quantum-physics',
        name: 'Quantum Physics',
        description: 'Deep purple, atomic, scientific.',
        component: QuantumPhysics,
    },
    {
        id: 'renewable-energy',
        name: 'Renewable Energy',
        description: 'Green, sustainable, clean energy.',
        component: RenewableEnergy,
    },
    {
        id: 'urban-planning',
        name: 'Urban Planning',
        description: 'Structured, architectural, city-focused.',
        component: UrbanPlanning,
    },
    {
        id: 'game-development',
        name: 'Game Development',
        description: 'Red, dynamic, interactive.',
        component: GameDevelopment,
    },
    {
        id: 'forensic-science',
        name: 'Forensic Science',
        description: 'Dark, investigative, detailed.',
        component: ForensicScience,
    },
    {
        id: 'archaeology-dig',
        name: 'Archaeology Dig',
        description: 'Earthy, historical, exploration.',
        component: ArchaeologyDig,
    },
    {
        id: 'astronomy-observatory',
        name: 'Astronomy Observatory',
        description: 'Deep blue, starry, cosmic.',
        component: AstronomyObservatory,
    },
    {
        id: 'podcast-media',
        name: 'Podcast Media',
        description: 'Bold pink, audio-visual, modern.',
        component: PodcastMedia,
    },
    {
        id: 'drone-pilot',
        name: 'Drone Pilot',
        description: 'Sky blue, tech, aerial.',
        component: DronePilot,
    },
    {
        id: 'ceramics-pottery',
        name: 'Ceramics Pottery',
        description: 'Earthy brown, artistic, tactile.',
        component: CeramicsPottery,
    },
    {
        id: 'yoga-wellness',
        name: 'Yoga Wellness',
        description: 'Lime green, calm, balance.',
        component: YogaWellness,
    },
    {
        id: 'equestrian-center',
        name: 'Equestrian Center',
        description: 'Brown, nature, animal care.',
        component: EquestrianCenter,
    },
    {
        id: 'scuba-diving',
        name: 'Scuba Diving',
        description: 'Ocean blue, underwater, exploration.',
        component: ScubaDiving,
    },
    {
        id: 'carpentry-wood',
        name: 'Carpentry Wood',
        description: 'Orange, craftsmanship, build.',
        component: CarpentryWood,
    },
    {
        id: 'electric-vehicle',
        name: 'Electric Vehicle',
        description: 'Green, tech, automotive.',
        component: ElectricVehicle,
    },
    {
        id: 'makeup-artistry',
        name: 'Makeup Artistry',
        description: 'Pink, fashion, beauty.',
        component: MakeupArtistry,
    },
    {
        id: 'stand-up-comedy',
        name: 'Stand Up Comedy',
        description: 'Bright red, spotlight, entertainment.',
        component: StandUpComedy,
    },
    {
        id: 'survival-skills',
        name: 'Survival Skills',
        description: 'Forest green, outdoor, preparedness.',
        component: SurvivalSkills,
    },
    {
        id: 'maritime-academy',
        name: 'Maritime Academy',
        description: 'Federal service aesthetic, Navy/Gold.',
        component: MaritimeAcademy,
    },
    {
        id: 'culinary-arts',
        name: 'Culinary Arts',
        description: 'High-end Michelin Star aesthetic.',
        component: CulinaryArts,
    },
    {
        id: 'robotics-engineering',
        name: 'Robotics Engineering',
        description: 'Clean technical lab aesthetic.',
        component: RoboticsEngineering,
    },
    {
        id: 'fashion-design-v2',
        name: 'Fashion Design V2',
        description: 'Avant-garde, brutalist high fashion.',
        component: FashionDesignV2,
    },
    {
        id: 'cinematography',
        name: 'Cinematography',
        description: 'Dark cinematic film school vibe.',
        component: Cinematography,
    },
    {
        id: 'interior-design',
        name: 'Interior Design',
        description: 'Soft editorial architectural style.',
        component: InteriorDesign,
    },
    {
        id: 'classical-conservatory',
        name: 'Classical Conservatory',
        description: 'Deep red/gold opera house aesthetic.',
        component: ClassicalConservatory,
    },
    {
        id: 'horticulture-botany',
        name: 'Horticulture Botany',
        description: 'Scientific botanical garden look.',
        component: HorticultureBotany,
    },
    {
        id: 'law-school-v2',
        name: 'Law School V2',
        description: 'Traditional Crimson/Slate authoritative style.',
        component: LawSchoolV2,
    },
    {
        id: 'cybersecurity',
        name: 'Cybersecurity',
        description: 'Dark mode terminal/hacker aesthetic.',
        component: Cybersecurity,
    },
    {
        id: 'space-architecture',
        name: 'Space Architecture',
        description: 'Sci-fi orbital engineering.',
        component: SpaceArchitecture,
    },
    {
        id: 'sports-science',
        name: 'Sports Science',
        description: 'High energy performance data.',
        component: SportsScience,
    },
    {
        id: 'wildlife-conservation',
        name: 'Wildlife Conservation',
        description: 'Explorer/National Geographic style.',
        component: WildlifeConservation,
    },
    {
        id: 'artificial-intelligence',
        name: 'Artificial Intelligence',
        description: 'Modern neural network aesthetic.',
        component: ArtificialIntelligence,
    },
    {
        id: 'journalism-media',
        name: 'Journalism Media',
        description: 'Newspaper grid and truth-focused.',
        component: JournalismMedia,
    },
    {
        id: 'sustainable-agriculture',
        name: 'Sustainable Agriculture',
        description: 'Organic farm-to-table vibe.',
        component: SustainableAgriculture,
    },
    {
        id: 'industrial-design',
        name: 'Industrial Design',
        description: 'Dieter Rams minimalist product design.',
        component: IndustrialDesign,
    },
    {
        id: 'acting-drama',
        name: 'Acting Drama',
        description: 'Dramatic theater and stage aesthetic.',
        component: ActingDrama,
    },
    {
        id: 'oceanography-research',
        name: 'Oceanography Research',
        description: 'Deep sea scientific exploration.',
        component: OceanographyResearch,
    },
    {
        id: 'creative-writing',
        name: 'Creative Writing',
        description: 'Literary manuscript vibe.',
        component: CreativeWriting,
    },
    {
        id: 'princeton',
        name: 'Princeton University',
        description: 'Orange/Black ivy league aesthetic.',
        component: PrincetonUniversity,
    },
    {
        id: 'mit',
        name: 'MIT',
        description: 'Minimalist technical aesthetic from MIT.',
        component: MIT,
    },
    {
        id: 'harvard',
        name: 'Harvard University',
        description: 'Crimson/Black prestigious classic.',
        component: HarvardUniversity,
    },
    {
        id: 'stanford',
        name: 'Stanford University',
        description: 'Cardinal red/white spacious design.',
        component: StanfordUniversity,
    },
    {
        id: 'yale',
        name: 'Yale University',
        description: 'Blue/White historic gothic style.',
        component: YaleUniversity,
    },
    {
        id: 'caltech',
        name: 'Caltech',
        description: 'Science/Space focused orange design.',
        component: Caltech,
    },
    {
        id: 'duke',
        name: 'Duke University',
        description: 'Duke Blue gothic architecture.',
        component: DukeUniversity,
    },
    {
        id: 'johns-hopkins',
        name: 'Johns Hopkins University',
        description: 'Blue/White medical research focus.',
        component: JohnsHopkinsUniversity,
    },
    {
        id: 'northwestern',
        name: 'Northwestern University',
        description: 'Purple/White modern academic.',
        component: NorthwesternUniversity,
    },
    {
        id: 'upenn',
        name: 'University of Pennsylvania',
        description: 'Red/Blue ivy league business style.',
        component: UniversityOfPennsylvania,
    },
    {
        id: 'uchicago',
        name: 'University of Chicago',
        description: 'Maroon/Gray core curriculum intellectual.',
        component: UniversityOfChicago,
    },
    {
        id: 'cornell',
        name: 'Cornell University',
        description: 'Carnelian Red/White rural ivy.',
        component: CornellUniversity,
    },
    {
        id: 'columbia',
        name: 'Columbia University',
        description: 'Columbia Blue/White NYC scholarly.',
        component: ColumbiaUniversity,
    },
    {
        id: 'brown',
        name: 'Brown University',
        description: 'Brown/Red open curriculum style.',
        component: BrownUniversity,
    },
    {
        id: 'ucla',
        name: 'UCLA',
        description: 'Blue/Gold optimist LA vibe.',
        component: UCLA,
    },
    {
        id: 'uc-berkeley',
        name: 'UC Berkeley',
        description: 'Berkeley Blue/Gold changemaker.',
        component: UCBerkeley,
    },
    {
        id: 'rice',
        name: 'Rice University',
        description: 'Blue/Gray unconventional wisdom.',
        component: RiceUniversity,
    },
    {
        id: 'dartmouth',
        name: 'Dartmouth College',
        description: 'Green/White outdoorsy ivy.',
        component: DartmouthCollege,
    },
    {
        id: 'vanderbilt',
        name: 'Vanderbilt University',
        description: 'Black/Gold southern ivy.',
        component: VanderbiltUniversity,
    },
    {
        id: 'notre-dame',
        name: 'University of Notre Dame',
        description: 'Navy/Gold catholic research.',
        component: NotreDame,
    },
    {
        id: 'umich',
        name: 'University of Michigan',
        description: 'Maize/Blue big public research.',
        component: UniversityOfMichigan,
    },
    {
        id: 'georgetown',
        name: 'Georgetown University',
        description: 'Blue/Gray DC jesuit tradition.',
        component: GeorgetownUniversity,
    },
    {
        id: 'unc',
        name: 'UNC Chapel Hill',
        description: 'Carolina Blue public ivy.',
        component: UNCChapelHill,
    },
    {
        id: 'cmu',
        name: 'Carnegie Mellon University',
        description: 'Red/Gray interdisciplinary tech.',
        component: CarnegieMellon,
    },
    {
        id: 'emory',
        name: 'Emory University',
        description: 'Blue/Gold atlanta healthcare.',
        component: EmoryUniversity,
    },
    {
        id: 'uva',
        name: 'University of Virginia',
        description: 'Orange/Blue jeffersonian.',
        component: UniversityOfVirginia,
    },
    {
        id: 'washu',
        name: 'Washington University in St. Louis',
        description: 'Red/Green midwest research.',
        component: WashU,
    },
    {
        id: 'usc',
        name: 'USC',
        description: 'Cardinal/Gold trojan family.',
        component: USC,
    },
    {
        id: 'ucsd',
        name: 'UC San Diego',
        description: 'Blue/Gold coastal innovation.',
        component: UCSanDiego,
    },
    {
        id: 'u-florida',
        name: 'University of Florida',
        description: 'Orange/Blue gator nation.',
        component: UniversityOfFlorida,
    },
    {
        id: 'ut-austin',
        name: 'University of Texas at Austin',
        description: 'Burnt Orange/White bold texas style.',
        component: UTAustin,
    },
    {
        id: 'uw-madison',
        name: 'University of Wisconsin-Madison',
        description: 'Badger Red/White lake campus.',
        component: UWMadison,
    },
    {
        id: 'uiuc',
        name: 'University of Illinois Urbana-Champaign',
        description: 'Orange/Blue innovation hub.',
        component: UIUC,
    },
    {
        id: 'georgia-tech',
        name: 'Georgia Institute of Technology',
        description: 'Gold/White tech focused.',
        component: GeorgiaTech,
    },
    {
        id: 'ohio-state',
        name: 'Ohio State University',
        description: 'Scarlet/Gray buckeye spirit.',
        component: OhioState,
    },
    {
        id: 'penn-state',
        name: 'Pennsylvania State University',
        description: 'Blue/White happy valley.',
        component: PennState,
    },
    {
        id: 'purdue',
        name: 'Purdue University',
        description: 'Old Gold/Black boilermaker engineering.',
        component: PurdueUniversity,
    },
    {
        id: 'rutgers',
        name: 'Rutgers University',
        description: 'Scarlet/Black revolutionary history.',
        component: RutgersUniversity,
    },
    {
        id: 'umaryland',
        name: 'University of Maryland',
        description: 'Red/White/Black/Gold terp pride.',
        component: UMaryland,
    },
    {
        id: 'texas-am',
        name: 'Texas A&M University',
        description: 'Maroon/White aggie tradition.',
        component: TexasAM,
    },
    {
        id: 'umass-amherst',
        name: 'University of Massachusetts Amherst',
        description: 'Maroon/White revolutionary research.',
        component: UMassAmherst,
    },
    {
        id: 'uc-irvine',
        name: 'University of California, Irvine',
        description: 'Blue/Gold anteater spirit.',
        component: UCIrvine,
    },
    {
        id: 'uc-davis',
        name: 'University of California, Davis',
        description: 'Blue/Gold aggie excellence.',
        component: UCDavis,
    },
    {
        id: 'uc-santa-barbara',
        name: 'University of California, Santa Barbara',
        description: 'Blue/Gold coastal campus.',
        component: UCSantaBarbara,
    },
    {
        id: 'boston-university',
        name: 'Boston University',
        description: 'Red/White city campus.',
        component: BostonUniversity,
    },
    {
        id: 'northeastern',
        name: 'Northeastern University',
        description: 'Red/Black experiential learning.',
        component: NortheasternUniversity,
    },
    {
        id: 'michigan-state',
        name: 'Michigan State University',
        description: 'Green/White spartan will.',
        component: MichiganStateUniversity,
    },
    {
        id: 'asu',
        name: 'Arizona State University',
        description: 'Maroon/Gold innovation leader.',
        component: ArizonaStateUniversity,
    },
    {
        id: 'umn',
        name: 'University of Minnesota',
        description: 'Maroon/Gold driven to discover.',
        component: UniversityOfMinnesota,
    },
    {
        id: 'indiana',
        name: 'Indiana University',
        description: 'Crimson/Cream hoosier spirit.',
        component: IndianaUniversity,
    },
    {
        id: 'design0-features',
        name: 'Orchard Premium Elite',
        description: 'A cutting-edge, high-conversion landing page design with glassmorphism effects and modern school infrastructure layouts.',
        component: Design0_Features,
    },
];

export const getDesignById = (id: string): React.FC<WebsiteDesignProps> | undefined => {
    return websiteDesigns.find(d => d.id === id)?.component;
};
